import { render, staticRenderFns } from "./reg-floting.vue?vue&type=template&id=387612ff&scoped=true&"
import script from "./reg-floting.vue?vue&type=script&lang=js&"
export * from "./reg-floting.vue?vue&type=script&lang=js&"
import style0 from "./reg-floting.vue?vue&type=style&index=0&id=387612ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387612ff",
  null
  
)

export default component.exports